import { isNumber } from './NumberUtils.js';

export const somenteNumeros = str => {
  let numero = '';
  str
    .split('')
    .filter(i => isNumber(i))
    .map(i => (numero += i));

  return numero;
};

export const somenteNumerosELetras = (str = '') => {
  return str.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
};

const CARACTERES_ACENTUADOS = {
  à: 'a',
  á: 'a',
  â: 'a',
  ã: 'a',
  ä: 'a',
  å: 'a',
  À: 'A',
  Á: 'A',
  Â: 'A',
  Ã: 'A',
  Ä: 'A',
  Å: 'A',
  ç: 'c',
  Ç: 'C',
  è: 'e',
  é: 'e',
  ê: 'e',
  ë: 'e',
  È: 'E',
  É: 'E',
  Ê: 'E',
  Ë: 'E',
  ì: 'i',
  í: 'i',
  î: 'i',
  ï: 'i',
  Ì: 'I',
  Í: 'I',
  Î: 'I',
  Ï: 'I',
  ñ: 'n',
  Ñ: 'N',
  ò: 'o',
  ó: 'o',
  ô: 'o',
  õ: 'o',
  ö: 'o',
  ø: 'o',
  Ò: 'O',
  Ó: 'O',
  Ô: 'O',
  Õ: 'O',
  Ö: 'O',
  Ø: 'O',
  ß: 's',
  ù: 'u',
  ú: 'u',
  û: 'u',
  ü: 'u',
  Ù: 'U',
  Ú: 'U',
  Û: 'U',
  Ü: 'U',
  ÿ: 'y',
  Ÿ: 'y',
  æ: 'ae',
  Æ: 'AE'
};

export const removeAcento = (valor = '') => {
  return valor.replace(
    /[àáâãäåÀÁÂÃÄÅçÇèéêëÈÉÊËìíîïÌÍÎÏñÑòóôõöøÒÓÔÕÖØßùúûüÙÚÛÜÿŸæÆ]/g,
    caractere => CARACTERES_ACENTUADOS[caractere]
  );
};

const REGRAS_SINGULAR_PT = [
  [/OES$/, 'AO'],
  [/AIS$/, 'AL'],
  [/EIS$/, 'EL'],
  [/OIS$/, 'OL'],
  [/UIS$/, 'UL'],
  [/([RZN])ES$/, '$1'],
  [/S$/, '']
];

const TAMANHO_MINIMO_SINGULAR = 4;

const singularizarPalavra = palavra => {
  if (palavra.length < TAMANHO_MINIMO_SINGULAR) {
    return palavra;
  }

  for (const [regex, substituicao] of REGRAS_SINGULAR_PT) {
    if (regex.test(palavra)) {
      return palavra.replace(regex, substituicao);
    }
  }

  return palavra;
};

export const singularizar = (valor = '') =>
  valor.replace(/\S+/g, singularizarPalavra);

export default {
  somenteNumeros,
  somenteNumerosELetras,
  removeAcento,
  singularizar
};
